export const TRANSLATIONS_EN = {
    sessionErrorTitle: 'Session expired',
    sessionErrorDescription: 'Your session expired or it is no longer valid. You need to login again.',
    genericErrorTitle: 'Something failed',
    genericErrorDescription:
        'At this moment Mi O2 is having technical problems. Please try again later, we are working to solve it as soon as possible.',
    consumption: 'Consumption',
    billPendingPayment: 'Pending payment',
};
